export enum GiTaskCategoryType {
  accounting = 'accounting',
  tax = 'tax',
  advice = 'advice',
  other = 'other',
  legal = 'legal',
  social = 'social',
  internalCabinet = 'internal_cabinet'
}
